import { render, staticRenderFns } from "./MenuBrickToolbox.vue?vue&type=template&id=d52bc4ce&"
import script from "./MenuBrickToolbox.vue?vue&type=script&lang=js&"
export * from "./MenuBrickToolbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d52bc4ce')) {
      api.createRecord('d52bc4ce', component.options)
    } else {
      api.reload('d52bc4ce', component.options)
    }
    module.hot.accept("./MenuBrickToolbox.vue?vue&type=template&id=d52bc4ce&", function () {
      api.rerender('d52bc4ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/MenuArea/MenuBrickToolbox.vue"
export default component.exports